import useBlogListingStore from 'layout/Listing/variants/blog/store';

import { toKebabCase } from 'utils/strings';

const checkFilters = (blog: { data: BlogResource }, filter: string) => {
  const tags = blog.data?.tags?.map(tag => toKebabCase(tag || '')) || [];

  return filter === 'All' || tags.includes(toKebabCase(filter));
};

const useFilterBlogs = (allBlogs: { data: BlogResource }[]) => {
  const activeFilter = useBlogListingStore(state => state.filters);
  const search = useBlogListingStore(state => state.search);

  if (!activeFilter && !search) {
    return allBlogs;
  }

  const filteredBlogs = allBlogs.filter(blog => {
    const isFiltered = checkFilters(blog, activeFilter);

    return isFiltered;
  });

  const searchedBlogs = filteredBlogs.filter(blog => blog?.data?.title?.toLowerCase().includes(search.toLowerCase()));

  return searchedBlogs;
};

export default useFilterBlogs;
